<template>
    
    <article class="reservation" v-if="data">

        <header>
            <h3>
                <router-link v-if="user.is_staff" :to="`/bookinglist/${ data.id }/edit`">{{ data.title }}</router-link>
                <router-link v-else :to="`/booking/${data.id}/`">{{ data.title }}</router-link>
            </h3>
            <p v-if="data.status === 0" class="status pending">Afventer godkendelse</p>
            <p v-if="data.status === 1" class="status approved">Godkendt</p>
            <p v-if="data.status === 2" class="status rejected">Afvist</p>
            <p v-if="data.status === 3" class="status cancelled">Slettet</p>
        </header>
        <dl>
            <dt>Reservation af</dt>
            <dd>{{ data.resource_name }}, {{ data.resource_admin_unit.name }}</dd>
            <dt>Periode</dt>
            <dd v-html="period"></dd>
            <dt>Reserveret af</dt>
            <dd v-if="data.creator_details">
                {{ data.creator_details.first_name }} {{ data.creator_details.last_name }}
                ({{ data.creator_details.email }})<br>
                <template v-if="data.creator_details.guest">
                    {{ data.creator_details.guest.address.zipcode }}
                    {{ data.creator_details.guest.address.town }}
                </template>
            </dd>
            <template v-if="data.description">
                <dt>Formål</dt>
                <dd>{{ data.description }}</dd>
            </template>
        </dl>
    
    </article>

</template>

<script>

    import { dateDjango2js, displayJSDate, displayJSTime } from '../../utils/Filters.js'
    import axios from '../../utils/Http.js'

    export default {
        props: [
            'data'
        ],
        data: function() {
            return {
                edit_mode: false
            }
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            },
            period: function() {
                let start = dateDjango2js(this.data.start),
                    end = dateDjango2js(this.data.end),
                    sameday = true
                if (displayJSDate(start) === displayJSDate(end)) {
                    return `${ displayJSDate(start) }, ${ displayJSTime(start) } - ${ displayJSTime(end) }`
                } else {
                    return `fra ${ displayJSDate(start) } ${ displayJSTime(start) } <br>til ${ displayJSDate(end) } ${ displayJSTime(end) }`
                }
            }
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    .reservation {
        padding: 1rem;

        header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            h2 {
                margin: 0;
                font-size: 1.25rem;
            }
        }
        .status {
            padding: .25rem .5rem;
            font-size: smaller;
            margin: 0 0 0 1rem;
            
            &.pending {
                background-color: $warning;
                color: darken($warning, 50%);
            }
            &.approved {
                background-color: $success;
                color: darken($success, 50%);
            }
            &.rejected {
                background-color: $danger;
                color: darken($danger, 50%);
            }
            &.cancelled {
                background-color: $grey8;
                color: $grey2;
            }
        }
    }

</style>
